import React from "react";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons/faLocationDot";

import { AtiraIcon } from "../../../../../components/AtiraIcon";
import { Flex } from "../../../../../components/Flex";
import { Text } from "../../../../../components/Text";
import { Button } from "../../../../../components/Button";
import { ConversationMessage } from "../../../../../model/integration/dto/meta/MetaConversationMessage";
import { useTheme } from "../../../../../ThemeContext";
import { Rounded } from "../../../../../theme/Rounded";
import { useTranslation } from "react-i18next";

type Props = {
  message: ConversationMessage;
};

export const WAMessageLocation: React.FC<Props> = ({ message }) => {
  const location = message.location;
  const { theme } = useTheme();
  const { t } = useTranslation();

  if (!location) {
    return null;
  }

  const latitude = Number(location.latitude);
  const longitude = Number(location.longitude);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return null;
  }

  const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
  const readableCoordinates = `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;

  return (
    <Flex
      flexDirection="column"
      alignItems="stretch"
      justifyContent="center"
      padding="m"
      gap="s"
      style={{
        background: theme.main,
        borderRadius: Rounded.md,
        width: 260,
      }}
    >
      <Flex alignItems="center" gap="s">
        <AtiraIcon icon={faLocationDot} color="white" />
        <Text color="white" fontSize="s" style={{ fontWeight: 600 }}>
          {location.name || "Shared location"}
        </Text>
      </Flex>

      {location.address ? (
        <Text color="darkSub" fontSize="xs" wordBreak="break-word">
          {location.address}
        </Text>
      ) : null}

      <Text color="white" fontSize="s" wordBreak="break-word">
        {readableCoordinates}
      </Text>

      <a
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ width: "100%", textDecoration: "none" }}
      >
        <Button
          icon={faLocationDot}
          width="100%"
          margin="none"
          backgroundColor="accent"
          hoverBackgroundColor="lightMain"
        >
          {t("common.whatsapp.location.openInMaps")}
        </Button>
      </a>
    </Flex>
  );
};
